import { storeConfiguration, setCustomColorTheme } from '@/store/configuration'
import { ApplicationConfiguration } from '@/types/api/app-configuration'
import { apiRequest } from './http-service'

async function getAppConfiguration() {
  return apiRequest<ApplicationConfiguration>('GET', 'configuration', { cancellationId: 'configuration' }).then(storeConfiguration).then(setCustomColorTheme)
}

export { getAppConfiguration }
